import React, { type Ref } from 'react';
import { ITAM_PRACTICE_HAM } from '@jira/itam__tenant-context/src/ItamProductContext.tsx';
import { itamRoute } from '@jira/router-routes__itam-routes/src/itamRoute.tsx';
import { MENU_ID_ITAM } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { useConfigurableMessageAndIconMap } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/controllers/use-configurable-message-and-icon-map/index.tsx';
import { MoreNavMenuButton } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/main.tsx';
import { generatePath } from '@atlassian/react-resource-router';
import { getMenuItemAnalytics } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/utils/get-analytics-attributes/index.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { HardwareSettingsMenuItems } from './HardwareSettingsMenuItems.tsx';

interface Props extends Nav4DragAndDropMenuItemProps {}

export const Nav4ITAMMenuLinkItem = (props: Props): React.JSX.Element => {
	const { draggableRef, dropIndicator, hasDragIndicator, isDragging, visualContentRef } = props;
	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(MENU_ID_ITAM);
	// oxlint-disable-next-line typescript/consistent-type-assertions
	const ref = draggableRef as Ref<HTMLAnchorElement> | undefined;

	const analytics = getMenuItemAnalytics({
		actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_ITAM],
		itemId: 'itam',
		level: 1,
	});

	return (
		<Nav4MenuLinkItem
			analytics={analytics}
			dropIndicator={dropIndicator}
			elemBefore={icon}
			hasDragIndicator={hasDragIndicator}
			href={generatePath(itamRoute.path, { practice: ITAM_PRACTICE_HAM })}
			isDragging={isDragging}
			menuId={MENU_ID_ITAM}
			ref={ref}
			testId="nav4-menu-item.sidenav-itam"
			visualContentRef={visualContentRef}
			actionsOnHover={
				<MoreNavMenuButton MenuItems={HardwareSettingsMenuItems} name={formattedMessage} />
			}
		>
			{formattedMessage}
		</Nav4MenuLinkItem>
	);
};
